import { render, staticRenderFns } from "./passwordUpdate.vue?vue&type=template&id=54e05c3a"
import script from "./passwordUpdate.vue?vue&type=script&lang=js"
export * from "./passwordUpdate.vue?vue&type=script&lang=js"
import style0 from "./passwordUpdate.vue?vue&type=style&index=0&id=54e05c3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports